// JavaScript
document.addEventListener("DOMContentLoaded", function () {
  const textContainer = document.getElementById("product__description");
  const readMoreButton = document.getElementById("read-more-button");
  const readMoreButtonText = document.getElementById('read-more-button-text')
  const readMoreButtonIcon = document.getElementById('read-more-button-icon')

  const firstChild = textContainer.firstElementChild

  firstChild.style.display = '-webkit-box'
  firstChild.style.webkitLineClamp = '3';
  firstChild.style.webkitBoxOrient = 'vertical'
  textContainer.style.maxHeight = `${firstChild.clientHeight.toString()}px`
  // Show the "Read More" button if the text overflows the container
  if (textContainer.scrollHeight > textContainer.clientHeight) {
    readMoreButton.style.display = "flex";
  } else {
    readMoreButton.style.display = "none";
  }
  console.log(textContainer.style)

  readMoreButton.addEventListener("click", function () {
    // Toggle between showing and hiding the full text
    if (textContainer.style.overflow === "hidden" || textContainer.style.overflow === "") {
      firstChild.style.display = 'block'
      textContainer.style.overflow = "visible";
      textContainer.style.maxHeight = "none";
      readMoreButtonText.innerText = "Réduire";
      readMoreButtonIcon.style.display = 'none'
    } else {
      firstChild.style.display = '-webkit-box'
      textContainer.style.overflow = "hidden";
      textContainer.style.maxHeight = `${firstChild.clientHeight.toString()}px` // Set the desired truncated height
      readMoreButtonText.innerText = "Voir plus";
      readMoreButtonIcon.style.display = 'flex'
    }
  });
});



// // JavaScript
// document.addEventListener("DOMContentLoaded", function () {
//   const textContainer = document.getElementById("product__description");
//   const readMoreButton = document.getElementById("read-more-button");
//   const readMoreButtonText = document.getElementById('read-more-button-text')
//   const readMoreButtonIcon = document.getElementById('read-more-button-icon')
//
//   const firstChild = textContainer.firstElementChild
//
//   firstChild.style.display = '-webkit-box'
//   firstChild.style.webkitLineClamp = '3';
//   firstChild.style.webkitBoxOrient = 'vertical'
//   textContainer.style.maxHeight = `${firstChild.clientHeight.toString()}px`
//
//   // Show the "Read More" button if the text overflows the container
//   if (textContainer.scrollHeight > textContainer.clientHeight) {
//     readMoreButton.style.display = "flex";
//   } else {
//     readMoreButton.style.display = "none";
//   }
//
//
//   if(firstChild.clientHeight === 0) {
//     textContainer.style.overflow = "hidden";
//     textContainer.style.display = '-webkit-box'
//     textContainer.style.webkitLineClamp = '3';
//     textContainer.style.webkitBoxOrient = 'vertical'
//     textContainer.style.maxHeight = `150px`
//     readMoreButton.addEventListener("click", function () {
//       if (textContainer.style.overflow === "hidden" || textContainer.style.overflow === "") {
//         textContainer.style.display = 'block'
//         textContainer.style.overflow = "visible";
//         textContainer.style.maxHeight = "none";
//         readMoreButtonText.innerText = "Réduire";
//         readMoreButtonIcon.style.display = 'none'
//       } else {
//         textContainer.style.display = '-webkit-box'
//         textContainer.style.overflow = "hidden";
//         textContainer.style.maxHeight = `150px` // Set the desired truncated height
//         readMoreButtonText.innerText = "Voir plus";
//         readMoreButtonIcon.style.display = 'flex'
//       }
//     });
//   } else {
//     readMoreButton.addEventListener("click", function () {
//       // Toggle between showing and hiding the full text
//       if (textContainer.style.overflow === "hidden" || textContainer.style.overflow === "") {
//         firstChild.style.display = 'block'
//         textContainer.style.overflow = "visible";
//         textContainer.style.maxHeight = "none";
//         readMoreButtonText.innerText = "Réduire";
//         readMoreButtonIcon.style.display = 'none'
//       } else {
//         firstChild.style.display = '-webkit-box'
//         textContainer.style.overflow = "hidden";
//         textContainer.style.maxHeight = `${firstChild.clientHeight.toString()}px` // Set the desired truncated height
//         readMoreButtonText.innerText = "Voir plus";
//         readMoreButtonIcon.style.display = 'flex'
//       }
//     });
//   }
//
//
//   // textContainer.style.opacity="1"
//
// });

//
// // JavaScript
// document.addEventListener("DOMContentLoaded", function () {
//   const textContainer = document.getElementById("product__description");
//   const readMoreButton = document.getElementById("read-more-button");
//   const readMoreButtonText = document.getElementById('read-more-button-text')
//   const readMoreButtonIcon = document.getElementById('read-more-button-icon')
//
//   // Show the "Read More" button if the text overflows the container
//   console.log(textContainer.scrollHeight )
//   console.log(textContainer.clientHeight)
//   if (textContainer.scrollHeight >= 150) {
//     readMoreButton.style.display = "flex";
//   } else {
//     readMoreButton.style.display = "none";
//   }
//
//   textContainer.style.overflow = "hidden";
//   textContainer.style.display = '-webkit-box'
//   textContainer.style.webkitLineClamp = '3';
//   textContainer.style.webkitBoxOrient = 'vertical'
//   textContainer.style.maxHeight = `150px`
//   readMoreButton.addEventListener("click", function () {
//     if (textContainer.style.overflow === "hidden" || textContainer.style.overflow === "") {
//       textContainer.style.display = 'block'
//       textContainer.style.overflow = "visible";
//       textContainer.style.maxHeight = "none";
//       readMoreButtonText.innerText = "Réduire";
//       readMoreButtonIcon.style.display = 'none'
//     } else {
//       textContainer.style.display = '-webkit-box'
//       textContainer.style.overflow = "hidden";
//       textContainer.style.maxHeight = `150px` // Set the desired truncated height
//       readMoreButtonText.innerText = "Voir plus";
//       readMoreButtonIcon.style.display = 'flex'
//     }
//   })
//
//
//   // textContainer.style.opacity="1"
//
// });
